import { render, staticRenderFns } from "./newsRecordList-dialog.vue?vue&type=template&id=eaf19ace&scoped=true"
import script from "./newsRecordList-dialog.vue?vue&type=script&lang=js"
export * from "./newsRecordList-dialog.vue?vue&type=script&lang=js"
import style0 from "./newsRecordList-dialog.vue?vue&type=style&index=0&id=eaf19ace&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf19ace",
  null
  
)

export default component.exports